<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
export default {
	props: {},
	watch: {},
	data() {
		return {
			//表格
			headData: getdata().headData,
			tableData: [],
			tablekey: 0
		};
	},
	mounted() {},
	created() {},
	methods: {
		//切换
		QieHuan() {
			this.$emit('switchingModeHuid', 2);
		},
		//返回
		switchingModeHuid() {
			this.$emit('switchingModeHuid', 0);
		},
		//表格字段排序
		sortchange(e) {
			console.log(e);
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
